import {Flex, Input, Modal, Space, Typography} from "antd";
import React, {useEffect} from "react";
import {Cover} from "../../components/Cover";
import '@mdxeditor/editor/style.css';
import {
    MDXEditor
} from '@mdxeditor/editor';
import {TagFlow} from "../../components/TagFlow";
import {Tag} from "../../feature/project/fields";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {useParams} from "react-router-dom";
import {Status} from "../../feature/project/status";
import {fetchTags} from "../../feature/project/projectsSlice";
import {Story} from "../../feature/project/story";
import {addStoryTag, removeStoryTag} from "../../feature/project/storySlice";

export interface StoryProps {
    story: Story,
    visible: boolean,
    onCancel: () => void,
    onSave: (story: Story) => void,
}

export const AddStoryModal = (props: StoryProps) => {
    const dispatch = useAppDispatch();
    const {projectId, storyId} = useParams();
    const allTags = useAppSelector(state => state.projects.tags)
    const status = useAppSelector(state => state.components.status)
    const [hasChanges, setHasChanges] = React.useState(false)
    const [title, setTitle] = React.useState(props.story.title)
    const [description, setDescription] = React.useState(props.story.description)
    const [cover, setCover] = React.useState(props.story.cover)
    const [tags, setTags] = React.useState<Array<Tag>>(props.story.tags || [])

    useEffect(() => {
        setTitle(props.story.title)
        setDescription(props.story.description || '')
        setCover(props.story.cover)
        setTags(props.story.tags || [])
    }, [props.visible, props.story, props.story.tags])

    useEffect(() => {
        setHasChanges(title !== props.story.title || description !== props.story.description || cover !== props.story.cover)
    }, [title, description, cover])

    useEffect(() => {
        if (status === Status.Idle && projectId && props.visible) {
            if (props.story.id) {
                dispatch(fetchTags({projectId: parseInt(projectId)}))
            }
        }
    }, [status, projectId, dispatch])

    return (
        <Modal
            maskClosable={false}
            open={props.visible}
            destroyOnClose={true}
            title={props.story.id ? 'Story Settings' : `Add Story`}
            okText={'Save'}
            okButtonProps={{disabled: !hasChanges}}
            onCancel={() => props.onCancel()}
            onOk={() => props.onSave({
                id: props.story.id,
                title: title || "",
                description: description || "",
                cover: cover,
                tags: tags
            })
            }
            width={1000}
        >
            <Flex gap={16}>
                <Cover
                    projectId={projectId}
                    style={{position: "relative", height: 400, width: 350, flex: 'none'}} cover={cover}
                    onFileUploaded={(url: string) => {
                        setCover(url)
                    }}/>
                <Space direction={'vertical'}
                       style={{width: '100%', maxHeight: 400, overflowY: 'auto', scrollbarWidth: "none"}} size={16}>
                    <div>
                        <Typography style={{fontWeight: 700}}>Title</Typography>
                        <Input value={title} onChange={(e) => setTitle(e.target.value)}/>
                    </div>
                    <div>
                        <Typography style={{fontWeight: 700}}>Synopsis</Typography>
                        <MDXEditor
                            className={"markdown-text"}
                            markdown={description || ""}
                            onChange={(e) => setDescription(e)}
                            plugins={[]}
                        />
                    </div>
                    <div>
                        <Typography style={{fontWeight: 700}}>Tags</Typography>
                        <TagFlow allTags={allTags}
                                 tags={tags}
                                 onTagAdded={(tag) => {
                                     setTags([...tags, tag])
                                     if (props.story.id && projectId) {
                                         dispatch(addStoryTag({
                                             projectId: parseInt(projectId),
                                             storyId: props.story.id,
                                             tag: {title: tag.title}
                                         }))
                                     }
                                 }}
                                 onTagDeleted={(tag) => {
                                     if (tag.id && props.story.id && projectId) {
                                         dispatch(removeStoryTag({
                                             projectId: parseInt(projectId),
                                             storyId: props.story.id,
                                             tagId: tag.id
                                         }))
                                     }
                                 }}
                        />
                    </div>
                </Space>
            </Flex>
        </Modal>
    )
        ;
}